<template>
    <footer id="footer" class="footer" :class="{ [`footer-${type}`]: type }" :data-background-color="backgroundColor">
        <div class="container text-center">
            <nav>
                <ul>
                    <li>
                        <a target="_blank" href="https://albinismo.es/contacto/">
                            Contacto
                        </a>
                    </li>
                </ul>
                <div class="copyright  text-center">
                    <b>ALBA. Asociación para la ayuda a personas con albinismo.</b>
                    <br />
                    Registro Nacional de Asociaciones del Ministerio del Interior: 587536. Declarada Entidad de Utilidad Pública en 2014. BOE: 7589 Orden INT/1264/2014, de 10 de junio
                </div>
            </nav>
        </div>
    </footer>
</template>
<script>
export default {
    props: {
        backgroundColor: String,
        type: String
    },
    data() {
        return {
            year: new Date().getFullYear()
        };
    }
};
</script>
<style></style>
